import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/integral/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/integral/exportExcel', data, {
    trim: true,
    download: true
  })
}

export function updateIntegral (data) {
  return request.post('/business/integral/updateIntegral', data)
}
